import React from "react";
import { Pencil, Trash } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

import { OptionsContainer, OptionItem } from "./ProjectDetailsOptions.styles.tsx";
import { ProjectDetailsOptionsProps } from "./ProjectDetailsOptions.types.tsx";

const ProjectDetailsOptions: React.FC<ProjectDetailsOptionsProps> = ({
  show,
  handleClose,
  onEdit,
  onDelete,
  canDelete,
}) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <OptionsContainer onMouseLeave={handleClose}>
      <OptionItem onClick={onEdit}>
        <Pencil className="me-2" />
        {t("projectDetailsOptions.edit")}
      </OptionItem>

      {/* El backend todavía deja borrar una hoja adoptada: comprueba el dueño y se lleva el
          linaje entero. Mientras eso siga así, esconder el botón es lo único que impide quitarle
          a un proyecto su alternativa definitiva desde esta pantalla. */}
      {canDelete && (
        <OptionItem danger onClick={onDelete}>
          <Trash className="me-2" />
          {t("projectDetailsOptions.delete")}
        </OptionItem>
      )}
    </OptionsContainer>
  );
};

export default ProjectDetailsOptions;
